export const GET_ALL_PACKAGES_REQUEST = "GET_ALL_PACKAGES_REQUEST";
export const GET_ALL_PACKAGES_RESPONSE = "GET_ALL_PACKAGES_RESPONSE";
export const ADD_NEW_PACKAGE_REQUEST = "ADD_NEW_PACKAGE_REQUEST";
export const ADD_NEW_PACKAGE_RESPONSE = "ADD_NEW_PACKAGE_RESPONSE";
export const GET_SINGLE_PACKAGE_REQUEST =
  "GET_SINGLE_PACKAGE_REQUEST";
export const GET_SINGLE_PACKAGE_RESPONSE =
  "GET_SINGLE_PACKAGE_RESPONSE";
export const EDIT_PACKAGE_REQUEST = "EDIT_PACKAGE_REQUEST";
export const EDIT_PACKAGE_RESPONSE = "EDIT_PACKAGE_RESPONSE";
export const DELETE_PACKAGE_REQUEST = "DELETE_PACKAGE_REQUEST";
